import { createRoute } from '@tanstack/react-router';
import { loginParentRoute } from 'pages/shared/Login/loginParentRoute';
import { z } from 'zod';

export const loginFromIdentityProviderRoute = createRoute({
  getParentRoute: () => loginParentRoute,
  path: '/from_identity_provider',
  validateSearch: z.object({
    auth_token: z.string().optional(),
  }),
}).lazy(() =>
  import('pages/shared/Login/FromIdentityProvider/FromIdentityProvider').then((d) => d.Route)
);
